import { useEffect } from "react";

/**
 * Hook to disable the browser context menu while the component is mounted.
 * Useful for drawing/editing modes where right-click has custom functionality.
 *
 * The context menu is automatically restored when the component unmounts.
 */
export const useDisableContextMenu = (): void => {
  useEffect(() => {
    // Save the original document context menu handler
    const originalDocumentOnContextMenu = document.oncontextmenu;

    // Disable context menu
    document.oncontextmenu = () => false;

    return () => {
      // Restore context menu on cleanup
      document.oncontextmenu = originalDocumentOnContextMenu;
    };
  }, []);
};
